module.exports = __webpack_public_path__ + "608cbd58088f13cef507275497f6b5dd.pdf";